/**
* Created by xuyq on 2021/1/8.
*/
<template>
  <mobile-main
    v-if='$isMobile'
    ref='mobileMain'
    :chatSessionList='chatSessionList'
    :systemLanguage='systemLanguage'
    :messages='messages'
    :loading='loading'
    :isOpsSuperAdmin='isOpsSuperAdmin'
    :showDetailFlag='showDetailFlag'
    :sendMessageLoading='sendMessageLoading'
    @openNewChat='openNewChat'
    @messageSearch='messageSearch'
    @deleteQueryMessage='openNewChat(); getChatHisMessages()'
    @componentEventHandle='componentEventHandle'
    @refreshAnswer='refreshAnswer'
    @reservation='reservation'
    @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
    @sendMessage='sendMessage'
    @thinkingCompleted='thinkingCompleted'
    @cancelChat="cancelChat"
  >
  </mobile-main>
  <div v-else class='w-full d-flex align-start main-content'
       style='height: 100%; overflow: hidden'>
    <div class='header-bar'></div>
    <chatbotLeftContent
      @miniChange='miniChange'
      @openNewChat='openNewChat'
      @messageSearch='messageSearch'
      :chatSessionList='chatSessionList'
      :queryHisData='queryHisData'
      @deleteQueryMessage='openNewChat(); getChatHisMessages()'
    ></chatbotLeftContent>
    <div class='pa-0 ml-0 position-relative' v-if='showDetailFlag'
         :style="{height: '100%', 'overflow-y': 'hidden', 'min-width': !mini ? 'calc(100% - 292px)' : 'calc(100% - 60px)'}">
      <top-navigation-bar></top-navigation-bar>

      <div ref='msgCard' class='chat-container fill-height'
           style='margin: 0 auto; position: relative; height: calc(90vh); overflow-y: auto; overflow-x: hidden; border: none'>
        <message-list
          ref='messageList'
          id='messageList'
          :language='systemLanguage'
          :messages='messages'
          :loading='loading'
          @scrollToBottom='scrollToBottom'
          @componentEventHandle='componentEventHandle'
          @refreshAnswer='refreshAnswer'
          @reservation='reservation'
          @cancelBookingCompletedEmit='cancelBookingCompletedEmit'
          @answerSatisfactionFeedbackEmit='answerSatisfactionFeedbackEmit'
          @thinkingCompleted='thinkingCompleted'
          @cancelChat="cancelChat"
        ></message-list>
      </div>
      <div class='position-absolute'
           style='width: 99%; display: grid; place-items: center; bottom: 0; background: #ffffff'>
        <message-input
          :inputWidth='inputWidth'
          @sendMessage='sendMessage'
          :sendMessageLoading='sendMessageLoading'
        ></message-input>
        <div style='font-size: 12px; color: #a3a3a3; margin-top: 6px; margin-bottom: 6px'>
          Copyright 2001-{{ new Date().getFullYear() }} © Accenture.All rights reserved.Accenture
          Confidential.For
          internal use only.
        </div>
      </div>
    </div>
    <div v-else :style="{width: mini ? 'calc(100% - 60px)' : 'calc(100% - 292px)'}">
      <chat-home @sendMessage='sendMessage'></chat-home>
    </div>

    <v-dialog v-model='systemShutdown' width='650' persistent no-click-animation>
      <v-img :src="require('@/assets/images/system-shutdown.png')"></v-img>
    </v-dialog>
  </div>
</template>
<script>

import {
  getChatBotQueryMessageHistoryList,
  regenerateAnswer,
  getChatSessionId,
  getChatLogsBySessionId,
  addReservationPlacesMessage,
  addPromptMessage,
  chatMessage,
  getLookUpByClassifyCode,
  customMessage,
  getLookUpByClassifyCodeV2,
} from '../../api'
import chatbotLeftContent from '@/modules/chat/components/ChatbotLeftContent20250515.vue'
import { store } from '@/myops/core'
import {
  saveChatSessionIdInLocalStore,
  set_conversation_id,
} from '../../util/ChatBotUtil'
import {
  checkFirstChar,
} from '../../util/index'
import ChatHome from '@/modules/chat/view/chatbot/component/ChatHome20250515.vue'
import MessageInput from '@/modules/chat/view/chatbot/component/MessageInput20250515.vue'
import MessageList from '@/modules/chat/view/chatbot/component/MessageList.vue'
import { mapGetters } from 'vuex'
import {
  mdiCogOutline, mdiCogRefresh,
} from '@mdi/js'
import MobileMain from './mobile/index.vue'
import FeedbackMenu from '@/modules/chat/view/chatbot/component/FeedbackMenu'
import TopNavigationBar from '@/modules/chat/view/chatbot/component/TopNavigationBar'

export default {
  components: {
    MessageInput,
    ChatHome,
    chatbotLeftContent,
    MessageList,
    MobileMain,
    FeedbackMenu,
    TopNavigationBar,
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    isOpsSuperAdmin() {
      return this.adminEidList.includes(this.eid)
    },
    inputWidth() {
      return Math.min((window.innerWidth - 292) * 0.8, 800)
    },
  },
  data() {
    return {
      systemShutdown: false,
      adminEidList: [],
      systemLanguage: 'chinese',
      showDetailFlag: false,
      newMessage: '',
      loading: false,
      messages: [],
      chatParam: {
        startDateTime: null,
        endDateTime: null,
      },
      icons: { mdiCogOutline, mdiCogRefresh },
      adminCogEnter: false,
      eid: store.state.user.user.eid,
      newMessageValid: true,
      queryHisData: {},
      mini: false,
      sendMessageLoading: false,
      // sse
      events: [],
      eventSource: null,
      titlePrefix: '',
      eventSourcePolyfill: null,
      sseIndex: 0,
      openDeepSeek: false,
      uploadFileDialog: false,
      lgiBody: {
        modelType: '',
        startDateTime: '',
        endDateTime: '',
      },
      collectInfoExMap: {
        city: '',
        date: '',
        time: '',
        person_count: 0,
        building_number: '',
        floor: '',
        capacity: '',
        time_minute_range: '',
      },
      chatSessionList: [],
      animationIdList: [],
      requestChatSet: new Set(),
      thinkingPromptWordList: [],
      pushMessageData: null,
      origin: window.location.origin,
    }
  },
  async created() {
    console.log('eid: ', store.state.user.user.eid, this.eid)
    this.$bus.$on('addMessage', data => this.addMessageBusEvent(data))
    await this.checkSystemShutdown()
    await this.initDefine()
    await this.getChatHisMessages()
    await this.getThinkingPromptWord()
  },
  mounted() {
  },
  beforeDestroy() {
    this.animationIdList.forEach(animationId => {
      cancelAnimationFrame(animationId)
    })
  },
  methods: {
    cancelChat(data) {
      console.log('cancelChat=====', this.chatSessionId, data)
      let mesData = {
        sender: 'bot',
        text: data.language ? '您的对话已结束 ，请重新预定' : 'Your conversation has ended, please rebook',
        answerType: 'msg',
        showSatisfaction: false,
      }
      this.messages.push(mesData)
      addPromptMessage({
        ...mesData,
        chatSessionId: this.chatSessionId,
      })
      // this.showDetailFlag = false
      store.commit('chat/SET_CHAT_SESSION_ID', '')
    },
    addMessageBusEvent(data) {
      if (data.type === 'answerSatisfactionFeedbackEmit') {
        this.answerSatisfactionFeedbackEmit(data)
      } else if (data.type === 'ticketCreateSuccess') {
        this.messages.push({
          sender: 'bot',
          answerType: 'ticketCreateSuccess',
          language: data.language,
          ticketNumber: data.ticket_number,
          ticketLink: data.ticket_link,
        })
        customMessage({
          chatSessionId: this.chatSessionId,
          queryContent: 'ITMS开工单提交成功提示',
          answerType: 'ticketCreateSuccess',
          answerContent: JSON.stringify(data),
        })
      } else if (data.type === 'ticketCreateError') {
        this.messages.push({
          sender: 'bot',
          answerType: 'ticketCreateError',
          language: data.language,
        })
        customMessage({
          chatSessionId: this.chatSessionId,
          queryContent: 'ITMS开工单提交失败提示',
          answerType: 'ticketCreateError',
        })
      }
      this.scrollToBottom()
    },
    answerSatisfactionFeedbackEmit(data) {
      if (data.value === '满意') {
        this.messages.push({
          sender: 'bot',
          answerType: 'msg',
          text: this.systemLanguage === 'chinese' ? '您的满意是我们的服务标准,若有其他需求欢迎随时联系,祝您生活愉快!' : 'Your satisfaction is our service standard. If you have any other needs, please feel free to contact us at any time. We wish you a happy life!',
          language: data.language,
          showSatisfaction: false,
        })
        customMessage({
          chatSessionId: this.chatSessionId,
          queryContent: data.language === 'chinese' ? '回答满意度提交-满意' : 'en-回答满意度提交-满意',
          answerType: 'msg',
          answerContent: this.systemLanguage === 'chinese' ? '您的满意是我们的服务标准,若有其他需求欢迎随时联系,祝您生活愉快!' : 'Your satisfaction is our service standard. If you have any other needs, please feel free to contact us at any time. We wish you a happy life!',
        })
      } else {
        this.messages.push({
          sender: 'bot',
          answerType: 'ticketSubmit',
          language: data.language,
          title: data.title,
          desc: data.desc,
        })
        customMessage({
          chatSessionId: this.chatSessionId,
          queryContent: data.language === 'chinese' ? '回答满意度提交-不满意' : 'en-回答满意度提交-不满意',
          answerType: 'ticketSubmit',
          answerContent: JSON.stringify({
            title: data.title,
            desc: data.desc,
          }),
        })
      }
    },
    async checkSystemShutdown() {
      getLookUpByClassifyCode({ classifyCode: 'CHATBOT_SYSTEM_SHUTDOWN' }).then(res => {
        const lookUps = res.data['CHATBOT_SYSTEM_SHUTDOWN']
        const lookUp = lookUps[0]
        this.systemShutdown = lookUp.value === 'YES'
      })
    },
    async initDefine() {
      store.commit('chat/SET_CHAT_SESSION_ID', '')
      store.commit('chat/SET_MODEL_TYPE', 'DeepSeek')
      set_conversation_id('')
      Object.keys(this.lgiBody).forEach(key => {
        this.lgiBody[key] = ''
      })
      Object.keys(this.collectInfoExMap).forEach(key => {
        this.collectInfoExMap[key] = ''
      })
      // getLookUpByClassifyCode({ classifyCode: 'CHATBOT_SHOW_SATIS_EID' }).then(res => {
      //   const lookUps = res.data['CHATBOT_SHOW_SATIS_EID']
      //   const lookUp = lookUps[0]
      //   const list = lookUp.value.split(/[,;]/)
      //   store.commit('chat/SET_SHOW_SATIS_EID', list)
      // })
      const {
        data: {
          code,
          data,
        },
      } = await getLookUpByClassifyCodeV2({ classifyCode: 'CSSA_ADMIN' })
      if (code === 200) {
        this.adminEidList = data.map(item => item.value)
      }
    },
    async getThinkingPromptWord() {
      const {
        data: {
          code,
          data,
        },
      } = await getLookUpByClassifyCode({ classifyCode: 'THINKING_PROMPT_WORD' })
      if (code === 200) {
        this.thinkingPromptWordList = data['THINKING_PROMPT_WORD'] || []
      }
    },
    addThink() {
      this.messages.push({
          sender: 'bot',
          type: 'thinking',
          avatar: this.sseIndex === 0,
          searchComplete: false,
          language: this.systemLanguage,
        },
      )
    },
    removeThink() {
      console.log('------removeThink------')
      this.messages = this.messages.filter(
        message => message.type !== 'thinking',
      )
    },
    async thinkingCompleted() {
      console.log('------thinkingCompleted#Thinking组件加载完成------', this.pushMessageData)
      this.removeThink()
      await this.pushMessage(this.pushMessageData)
      this.pushMessageData = null
    },
    async sendMessage(message) {
      if (!message || !message.trim()) {
        this.$message.error('您没有输入内容哦')
        return
      }
      this.systemLanguage = checkFirstChar(message)
      this.sendMessageLoading = true
      this.newMessage = message.trim()
      this.messages.push({ sender: 'user', text: this.newMessage })
      this.showDetailFlag = true
      await this.chatMessageApi(this.newMessage)
      this.sendMessageLoading = false
      this.newMessage = '' // 清空输入框
    },
    async newChatAddToLeftMessageList(message) {
      if (!this.chatSessionList.some(chat => chat.chatSessionId === this.chatSessionId)) {
        this.chatSessionList.unshift({
          chatSessionId: null,
          queryName: message,
        })
      }
    },
    openChatTimer(requestId) {
      const chatTimer = setTimeout(() => {
        if (this.requestChatSet.has(requestId)) {
          console.log('请求超过十秒了！！！')
          this.removeThink()
          const thinkingPromptWord = this.thinkingPromptWordList[0]
          let promptText
          if (this.systemLanguage === 'chinese') {
            promptText = thinkingPromptWord ? thinkingPromptWord.value : '思考中，请稍后。您还需等待约20秒。'
          } else {
            promptText = thinkingPromptWord ? thinkingPromptWord.attr1 : 'Thinking, please wait. This will take about 20 seconds.'
          }
          this.messages.push({ sender: 'bot', type: 'thinking', text: promptText })
        }
      }, 1000 * 10)
      return chatTimer
    },
    clearChatTimer(chatTimer, requestId) {
      this.removeThink()
      this.requestChatSet.delete(requestId)
      if (chatTimer) {
        clearTimeout(chatTimer)
      }
    },
    AISearchComplete() {
      console.log('------AISearchComplete#AI接口调用完成------', this.messages)
      this.messages.forEach(message => {
        if (message.type === 'thinking') {
          message.searchComplete = true
        }
      })
    },
    async chatMessageApi(message, messageType) {
      this.addThink()
      const requestId = 'chat-message' + new Date().getTime()
      this.requestChatSet.add(requestId)
      // const chatTimer = this.openChatTimer(requestId)
      this.scrollToBottom()
      try {
        await this.newChatAddToLeftMessageList(message)
        const { data: { code, data } } = await chatMessage({
          chatSessionId: this.chatSessionId,
          query: message,
          messageType: messageType,
        })
        // this.clearChatTimer(chatTimer, requestId)
        if (code === 200) {
          console.log(data.end, data.end, data.end)
          if (data.end) {
            store.commit('chat/SET_CHAT_SESSION_ID', '')
          } else {
            store.commit('chat/SET_CHAT_SESSION_ID', data.conversationId)
          }
          this.pushMessageData = data
          if (data.text === '停机维护') {
            this.systemShutdown = true
            return
          }
          this.AISearchComplete()
          // setTimeout(async () => await this.pushMessage(data), 800)

          // setTimeout(async () => {
          //   if (data.markdownMag) {
          //     this.messages.push({
          //       sender: 'bot',
          //       text: data.markdownMag,
          //       type: 'markdown',
          //       showSatisfaction: data.answerCategory === 'IT',
          //     })
          //   }
          //   this.systemLanguage = data.tipMsg ? checkFirstChar(data.tipMsg) : this.systemLanguage ? this.systemLanguage : 'chinese'
          //   this.messages.push({
          //     sender: 'bot',
          //     ...data,
          //     hideAvatar: !!data.markdownMag,
          //     cityDisabled: false,
          //     dateDisabled: false,
          //     buildingDisabled: false,
          //     componentDisabled: false,
          //     language: this.systemLanguage,
          //     showSatisfaction: data.answerCategory === 'IT',
          //   })
          //   if (!this.chatSessionList.some(chat => chat.chatSessionId === this.chatSessionId)) {
          //     await this.getChatHisMessages()
          //   }
          //   this.scrollToBottom()
          // }, 1000 * 5)
        }
      } catch (e) {
        console.error('----chatMessageApi---', e)
      }
      // this.removeThink()
    },
    async pushMessage(data) {
      console.log('---------添加AI消息---------', data)
      this.systemLanguage = data.answerLanguageType

      if (data.markdownMag) {
        // this.systemLanguage = checkFirstChar(data.markdownMag)
        this.messages.push({
          sender: 'bot',
          text: data.markdownMag,
          type: 'markdown',
          showSatisfaction: data.answerCategory === 'Common-IT',
          language: this.systemLanguage,
        })
      }

      // if (data.answerType === 'msg' && !!data.text) {
      //   this.systemLanguage = checkFirstChar(data.text)
      // }
      this.messages.push({
        sender: 'bot',
        ...data,
        hideAvatar: !!data.markdownMag,
        cityDisabled: false,
        dateDisabled: false,
        buildingDisabled: false,
        componentDisabled: false,
        language: this.systemLanguage,
        showSatisfaction: data.answerCategory === 'Common-IT',
      })
      if (!this.chatSessionList.some(chat => chat.chatSessionId === this.chatSessionId)) {
        await this.getChatHisMessages()
      }
      this.scrollToBottom()
    },
    componentEventHandle(data) {
      this.chatMessageApi(data.message, 'component')
    },
    async reservation(item) {
      let msg
      if (item.reservationFlag) {
        msg = item.bookedPlaceResult.state === 'Awaiting approval' ? 'awaitingApproval' : 'bookingSuccess'
      } else {
        msg = this.$isMobile ? 'errorBookedNotice' : 'messagePrompt'
        item.promptTitle = this.systemLanguage === 'chinese' ? '预订失败' : 'Booking failed'
      }
      addReservationPlacesMessage({
        sender: 'bot',
        msg: msg,
        ...item,
        loadMore: true,
        type: 'render',
        chatSessionId: this.chatSessionId,
      }).then(res => {
        this.messages.push({
          sender: 'bot',
          msg: msg,
          ...item,
          loadMore: true,
          type: 'render',
          errorMag: item.errorMag,
          promptMessage: item.promptTitle,
          language: this.systemLanguage,
        })
        this.scrollToBottom()
      })
    },
    async cancelBookingCompletedEmit(data) {
      this.messages.push({
        sender: 'bot',
        msg: 'cancelBookedNotice',
        type: 'render',
        language: this.systemLanguage,
        ...data,
      })
      this.scrollToBottom()
      addPromptMessage({
        sender: 'bot',
        msg: 'cancelBookedNotice',
        promptMessage: '取消预订',
        cityName: data.cityName,
        code: data.code,
        buildName: data.buildName,
        roomName: data.roomName,
        start: data.start,
        end: data.end,
        errorMsg: data.errorMsg,
        type: 'render',
        chatSessionId: this.chatSessionId,
      })
    },
    async getNewChatSessionId() {
      const { data: { code, data } } = await getChatSessionId()
      if (code === 200) {
        saveChatSessionIdInLocalStore(data)
      }
    },
    async getChatHisMessages() {
      const { data: { code, data } } = await getChatBotQueryMessageHistoryList()
      if (code === 200) {
        this.chatSessionList = []
        this.queryHisData = data
        Object.keys(data).forEach(key => {
          this.chatSessionList = this.chatSessionList.concat(this.queryHisData[key])
        })
      }
    },
    async refreshAnswer(message) {
      if (this.modelType !== 'myops' && message.queryContent) {
        await this.sendMessage(message.queryContent)
      } else {
        this.loading = true
        const { data: { code, data } } = await regenerateAnswer({ answerId: message.msgId })
        this.loading = false
        if (code === 200) {
          this.messages.push({
            sender: 'bot',
            ...data,
            loadMore: true,
            text: data.msg,
            dataRange: [],
          })
          this.scrollToBottom()
        }
      }
    },
    miniChange(val) {
      this.mini = val
    },
    async openNewChat() {
      this.messages = []
      this.showDetailFlag = false
      this.openDeepSeek = false
      this.initDefine()
      this.getChatHisMessages()
      // await this.getNewChatSessionId()
    },
    scrollToBottom() {
      this.$nextTick(() => {
          const container = this.$refs.msgCard
          if (container && container.scrollTo) {
            // 使用requestAnimationFrame确保在渲染下一帧前执行
            const animationId = requestAnimationFrame(() => {
                container.scrollTo({
                  top: container.scrollHeight,
                  behavior: 'smooth', // 添加平滑滚动效果
                })
              },
            )
            this.animationIdList.push(animationId)
          } else if (this.$refs.mobileMain) {
            this.$refs.mobileMain.scrollToBottom()
          }
        },
      )
    },
    async messageSearch(item) {
      const {
        data: {
          code,
          data,
        },
      } = await getChatLogsBySessionId({ chatSessionId: item.chatSessionId })
      if (code === 200 && data) {
        this.messages = []
        this.showDetailFlag = true
        data.forEach(i => {
          this.systemLanguage = i.languageType
          if (!!i.queryRequestParams) {
            const queryRequestParams = JSON.parse(i.queryRequestParams)
            if (queryRequestParams.building_number) {
              this.collectInfoExMap.building_number = queryRequestParams.building_number
            }
            if (queryRequestParams.capacity) {
              this.collectInfoExMap.capacity = queryRequestParams.capacity
            }
            if (queryRequestParams.city) {
              this.collectInfoExMap.city = queryRequestParams.city
            }
            if (queryRequestParams.floor) {
              this.collectInfoExMap.floor = queryRequestParams.floor
            }
            if (queryRequestParams.person_count) {
              this.collectInfoExMap.person_count = queryRequestParams.person_count
            }
            if (queryRequestParams.time_minute_range) {
              this.collectInfoExMap.time_minute_range = queryRequestParams.time_minute_range
            }
          }
          store.commit('chat/SET_MODEL_TYPE', i.modelType)
          if (i.queryType === 'user' && i.queryContent) {
            this.messages.push({ sender: 'user', text: i.queryContent, type: i.answerType })
          }
          if (i.answerType === 'component') {
            const answerContent = JSON.parse(i.answerContent)
            this.messages.push({
              sender: 'bot',
              ...answerContent,
              queryRequestParams: JSON.parse(i.queryRequestParams),
              dataRange: [],
              msgId: i.ansId,
              likeType: i.likeType,
              queryContent: i.queryContent,
              immediatelyRender: true,
              loadMore: true,
              componentSelectionValue: i.componentSelectionValue,
              cityDisabled: true,
              dateDisabled: true,
              buildingDisabled: true,
              componentDisabled: true,
              language: this.systemLanguage,
              satisfactionFeedback: i.satisfactionFeedback,
            })
          } else {
            // this.systemLanguage = i.queryContent ? checkFirstChar(i.queryContent) : this.systemLanguage ? this.systemLanguage : 'chinese'
            // if (i.answerType === 'msg') {
            //   this.systemLanguage = checkFirstChar(i.answerContent)
            // }
            let messageItem = {
              sender: 'bot',
              msg: i.answerContent,
              text: i.answerContent,
              answerType: i.answerType,
              dataRange: [],
              msgId: i.ansId,
              likeType: i.likeType,
              immediatelyRender: true,
              type: i.answerType,
              language: this.systemLanguage,
              queryContent: i.queryContent,
              satisfactionFeedback: i.satisfactionFeedback,
              ticketSubmitDisabled: true,
              showSatisfaction: i.answerCategory === 'Common-IT',
            }
            if (i.answerType !== 'msg' && !!i.answerContent) {
              const ansContextObj = JSON.parse(i.answerContent)
              if (i.answerType === 'ticketCreateSuccess') {
                messageItem.ticketNumber = ansContextObj.ticket_number
                messageItem.ticketLink = ansContextObj.ticket_link
              } else if (i.answerType === 'ticketSubmit') {
                messageItem.title = ansContextObj.title
                messageItem.desc = ansContextObj.desc
              }
            }
            this.messages.push(messageItem)
          }
        })
        this.scrollToBottom()
      }
    },
  }
  ,
}

</script>
<style lang='scss' scoped>
.chat-container {
  display: flex;
  flex-direction: column;
}

.header-bar {
  width: 100%;
  height: 6px;
  background: #7f26d3;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}

.main-content {
}

::v-deep .no-border-textarea .v-input__control {
  border: none !important;
  //height: 112px;
}

::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
  padding: 2px 18px;
}

.gradient-text {
  font-size: 24px;
  font-weight: bold;
  background: linear-gradient(270.00deg, #a100ff 0%, #d87ab7 100%);
  -webkit-background-clip: text;
  color: transparent;
}

::v-deep .v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner {
  align-self: flex-end !important;
}
</style>
